/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Base from 'shared/client/behavior/base';


export default class extends Base
{
  canNavigate ()
  {
    return true;
  }


  canSelect ()
  {
    return false;
  }


  isPaneCollapsed ()
  {
    return true;
  }


};
